var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-mobile',[_c('div',{staticClass:"comms_filter flex flex-end"},[_c('comms-filters')],1),_vm._v(" "),_c('comms-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }